<div class="pdf-second-page-container">

  <div class="content-wrapper">

    <div class="demographic-section">
      <div class="section-header-container">
        <div class="section-title">DEMOGRAPHIC PROFILE</div>
        <div>
          <span class="region-label">Current Region: </span>
          <span class="region-value">{{ regionText }}</span>
        </div>
      </div>
      <div class="section-description">
            This is a profile of the population in this store's local area. Consider this profile to be the first step towards understanding this store's target customer base, and how the local demographics may be affecting this store's performance.
          </div>
      <div class="demographic-content">
        <div class="ethnicity-header">
          <div class="ethnicity-title-col">
            <div class="demographic-title">ETHNICITY</div>
            <div class="demographic-divider"></div>
          </div>
          <div class="population-title-col">
            <div class="demographic-title">POPULATION</div>
            <div class="demographic-divider"></div>
          </div>
        </div>
        <div class="ethnicity-population-row">
          <div class="ethnicity-box">
            <div class="ethnicity-background"></div>
            <div class="ethnicity-breakdown">
              <div class="ethnicity-labels">
                <div class="ethnicity-label-other">Other</div>
                <div class="ethnicity-label">Asian</div>
                <div class="ethnicity-label">White</div>
                <div class="ethnicity-label-hispanic">Hispanic</div>
                <div class="ethnicity-label">Black</div>
              </div>
              <div class="ethnicity-values">
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.other }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.asian }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.white }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.hispanic }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.black }}%</div>
              </div>
            </div>
          </div>
          <div class="population-cards">
            <div class="population-card">
              <div class="population-card-content">
                <div class="population-card-bg"></div>
                <div class="population-card-icon population-card-icon-growth">
                  <img src="assets/images/Vector.png" style="width: 30.24px; height: 30.24px; left: 0.49px; top: 0.49px; position: absolute;">
                </div>
                <div class="population-card-label population-card-label-growth">Historical 2yr Growth</div>
              </div>
              <div class="population-card-value">{{ demographicData.population.growth2yr > 0 ? '+' : '' }}{{ demographicData.population.growth2yr }}%</div>
            </div>
            <div class="population-card">
              <div class="population-card-content">
                <div class="population-card-bg"></div>
                <img src="assets/images/Vector (1).png" class="population-card-icon-total" style="position: absolute;">
                <div class="population-card-label population-card-label-total">TOTAL POPULATION</div>
              </div>
              <div class="population-card-value">{{ formatNum(demographicData.population.total) }}</div>
            </div>
            <div class="population-card">
              <div class="population-card-content">
                <div class="population-card-bg"></div>
                <div class="population-card-label population-card-label-household">Projected 5yr Growth</div>
                <div class="population-card-icon population-card-icon-household">
                  <img src="assets/images/Vector (2).png" style="width: 28.01px; height: 21.01px; left: 0px; top: 3.50px; position: absolute;">
                </div>
              </div>
              <div class="population-card-value">{{ demographicData.population.householdGrowth2yr > 0 ? '+' : '' }}{{ demographicData.population.householdGrowth2yr }}%</div>
            </div>
          </div>
        </div>
        <div class="people-income-section">
          <div class="people-income-header">
            <div class="people-title-col">
              <div class="people-income-title">PEOPLE</div>
              <div class="demographic-divider"></div>
            </div>
            <div class="income-title-col">
              <div class="people-income-title">INCOME</div>
              <div class="demographic-divider"></div>
            </div>
          </div>
          <div class="people-income-cards">
            <div class="people-cards">
              <div class="population-card">
                <div class="population-card-content">
                  <div class="people-card-bg"></div>
                  <div class="people-card-label people-card-label-age">AVERAGE AGE</div>
                  <div class="population-card-icon" style="width: 28.31px; height: 28.31px; left: 24.51px; top: 23.51px; position: absolute; overflow: hidden;">
                    <img src="assets/images/Vector (3).png" style="width: 27.43px; height: 27.43px; left: 0.44px; top: 0.44px; position: absolute;">
                  </div>
                </div>
                <div class="population-card-value">{{ formatNumDecimal(demographicData.people.averageAge) }}</div>
              </div>
              <div class="population-card">
                <div class="population-card-content">
                  <div class="people-card-bg"></div>
                  <div class="people-card-label people-card-label-educated">COLLEGE EDUCATED</div>
                  <div class="population-card-icon" style="width: 38.02px; height: 30.41px; left: 19.42px; top: 25.51px; position: absolute; overflow: hidden;">
                    <img src="assets/images/Vector (4).png" style="width: 38.02px; height: 22.81px; left: 0px; top: 3.80px; position: absolute;">
                  </div>
                </div>
                <div class="population-card-value">{{ demographicData.people.educated }}%</div>
              </div>
              <div class="population-card">
                <div class="population-card-content">
                  <div class="people-card-bg"></div>
                  <div class="people-card-label people-card-label-household">HOUSEHOLD SIZE</div>
                  <div class="population-card-icon" style="width: 30.84px; height: 27.41px; left: 22.84px; top: 24.01px; position: absolute; overflow: hidden;">
                    <img src="assets/images/Vector (5).png" style="width: 30.84px; height: 23.98px; left: 0px; top: 1.72px; position: absolute;">
                  </div>
                </div>
                <div class="population-card-value">{{ formatNumDecimal(demographicData.people.householdSize) }}</div>
              </div>
            </div>
            <div class="income-cards">
              <div class="population-card">
                <div class="population-card-content">
                  <div class="income-card-bg"></div>
                  <div class="income-card-label income-card-label-average">AVERAGE INCOME</div>
                   <div class="icon-container">
                    <img src="assets/images/Vector (8).png" style="width: 17px; height: 31px; left: 26px; top: 19px; position: absolute;">
                  <img src="assets/images/Vector (6).png" style="width: 14px; height: 11px; left: 35px; top: 33px; position: absolute;">
                  </div>
                  </div>
                <div class="population-card-value">{{ formatNum(demographicData.income.average) }}</div>
              </div>
              <div class="population-card">
                <div class="population-card-content">
                  <div class="income-card-bg"></div>
                  <div class="income-card-label income-card-label-median">MEDIAN INCOME</div>
                   <div class="icon-container">
                    <img src="assets/images/Vector (8).png" style="width: 17px; height: 31px; left: 26px; top: 19px; position: absolute;">
                  <img src="assets/images/Vector (6).png" style="width: 14px; height: 11px; left: 35px; top: 33px; position: absolute;">
                  </div>
                  </div>
                <div class="population-card-value">{{ formatNum(demographicData.income.median) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-provider">
      <div class="data-provider-text">Demographic data provided by Synerpos Technologies, Inc.</div>
    </div>
    <div class="banner-analysis-section" *ngIf="!shouldHideBannerAnalysisInSecondPage()">
      <div class="banner-analysis-header">
        <div class="banner-analysis-info">
          <div class="banner-analysis-title-row">
            <div class="banner-analysis-title">BANNER ANALYSIS: {{ bannerAnalysis.banner }}</div>
          </div>
          <div class="banner-analysis-market">In the {{ bannerAnalysis.market }}</div>
          <div class="banner-analysis-description">Compare the entire banner's performance in the market. How does this store's banner compare to all other banners with a presence in the market?</div>
        </div>
      </div>
      <div class="banner-performance-row">
        <div class="banner-perf-item" *ngIf="bannerAnalysis.salesSqft">
          <div class="banner-perf-canvas">
            <canvas width="28" height="28"
                    [attr.data-percentile]="bannerAnalysis.salesSqft.percentile"
                    [attr.data-color]="bannerAnalysis.salesSqft.color"
                    class="banner-mini-chart"></canvas>
            <div class="banner-perf-percentile">{{ bannerAnalysis.salesSqft.percentile }}</div>
          </div>
          <div class="banner-perf-text">
            <div class="banner-perf-prefix">{{ bannerAnalysis.salesSqft.prefix }}</div>
            <div class="banner-perf-title">{{ bannerAnalysis.salesSqft.status }}</div>
            <div class="banner-perf-subtitle">{{ bannerAnalysis.salesSqft.description }}</div>
          </div>
        </div>

        <div class="banner-perf-item" *ngIf="bannerAnalysis.storeCount">
           <div class="banner-perf-canvas">
            <canvas width="28" height="28"
                    [attr.data-percentile]="bannerAnalysis.storeCount.percentile"
                    [attr.data-color]="bannerAnalysis.storeCount.color"
                    class="banner-mini-chart"></canvas>
            <div class="banner-perf-percentile">{{ bannerAnalysis.storeCount.percentile }}</div>
          </div>
          <div class="banner-perf-text">
            <div class="banner-perf-prefix">{{ bannerAnalysis.storeCount.prefix }}</div>
            <div class="banner-perf-title">{{ bannerAnalysis.storeCount.status }}</div>
            <div class="banner-perf-subtitle">{{ bannerAnalysis.storeCount.description }}</div>
          </div>
        </div>

        <div class="banner-perf-item" *ngIf="bannerAnalysis.salesVolume">
          <div class="banner-perf-canvas">
            <canvas width="28" height="28"
                    [attr.data-percentile]="bannerAnalysis.salesVolume.percentile"
                    [attr.data-color]="bannerAnalysis.salesVolume.color"
                    class="banner-mini-chart"></canvas>
            <div class="banner-perf-percentile">{{ bannerAnalysis.salesVolume.percentile }}</div>
          </div>
          <div class="banner-perf-text">
            <div class="banner-perf-prefix">{{ bannerAnalysis.salesVolume.prefix }}</div>
            <div class="banner-perf-title">{{ bannerAnalysis.salesVolume.status }}</div>
            <div class="banner-perf-subtitle">{{ bannerAnalysis.salesVolume.description }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-section">
  <img height="30" width="30" src="assets/images/resized-retailstat-icon.png" />
  <div class="footer-content">
    <div class="footer-text-row">
      <span class="footer-text">Powered by </span>
      <span class="footer-text-brand">Retailstat</span>
      <span class="footer-text-rights">All Rights Reserved.</span>
    </div>
  </div>

</div>
  </div>

  <div class="competitive-pattern-line">
     <div class="pattern-segment"></div>
     <div class="pattern-segment"></div>

</div>
